import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    root: {},
    hint: {
      color: '#3f505a',
      fontSize: 14,
      fontWeight: 'normal',
      marginBottom: theme.spacing(3),
    },
    progress: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    counts: {
      color: '#3f505a',
      fontSize: 14,
      fontWeight: 'bold',
      marginBottom: theme.spacing(2),
    },
    headLine: {
      marginBottom: theme.spacing(1),
    },
  }));